module.exports = __webpack_public_path__ + "img/blockables-arrows-3x3.82c66b64.png";